import styled from "styled-components";


const FlexStyled = styled.div`
display: flex;
justify-content: ${props => props.justifyContent};
align-items: ${props => props.alignItems};
flex-direction: ${props => props.direction};
margin-left: ${props => props.marginLeft} ;
margin-right: ${props => props.marginRight} ;
margin-top: ${props => props.marginTop} ;
`

const Flex = ({children,justifyContent,alignItems,direction, marginLeft,marginRight,marginTop}) =>{

    return(
        <FlexStyled children={children} justifyContent={justifyContent} alignItems={alignItems } direction={direction} marginLeft={marginLeft} marginRight={marginRight} marginTop={marginTop}/>

    )
}

export default Flex;